module.exports = __webpack_public_path__ + "static/media/black-circle.6ec1481e.svg";